import { createContext, useContext } from 'react';

export const SessionExpiryContext = createContext<number | null>(null);

export const useSessionExpiryContext = () => useContext(SessionExpiryContext);
